import Row from "@amzn/meridian/row";
import {injectIntl} from "react-intl";
import Column from "@amzn/meridian/column";
import Button from "@amzn/meridian/button";
import Box from "@amzn/meridian/box";
import React, {useContext, useState} from "react";
import SearchField from "@amzn/meridian/search-field";
import {ALL_CONFIG, EMPTY_STRING, LOGS, MAX_LOGS_COUNT, UNDERSCORE} from "../util/Constants";
import {getLocalizedMessage} from "../util/Localization";
import {LogStoreContext} from "../store/context/LogStoreContext";
import Select, {SelectOption} from "@amzn/meridian/select";
import Input from "@amzn/meridian/input";
import DownloadFile from "./DownloadFile";

const LogstreamTabHeader = (props) => {
    const {logData, setMaxMessageCount, filterLogs, clearLogs} = useContext(LogStoreContext);
    const [messageCount, setMessageCount] = useState(MAX_LOGS_COUNT)
    const [errorMsg, setErrorMsg] = useState(EMPTY_STRING)
    const {intl, isSubscribing, setIsSubscribing, deviceList, eventType, deviceType, setError} = props;

    const toggleText = () => {
        setIsSubscribing(!isSubscribing);
        setError(false);
    };

    const downloadFileProps = {
        downloadButtonName: getLocalizedMessage({intl, stringId: 'log.download'}),
        data: logData.filteredLogs,
        eventType,
        deviceType,
        prefix: deviceType + UNDERSCORE + LOGS
    }

    return (
        <Column>
            <Box type="fill" spacingInset="medium">
                <Row alignmentHorizontal="justify" widths={["fill"]} spacing="400">
                    <Row alignmentHorizontal="start">
                        {isSubscribing
                            ? <Button size="small" onClick={toggleText}>{getLocalizedMessage({intl, stringId: 'log.stopMonitoring'})}</Button>
                            : <Button size="small" onClick={toggleText}>{getLocalizedMessage({intl, stringId: 'log.startMonitoring'})}</Button>
                        }
                        <Button size="small" onClick={clearLogs} type="tertiary">{getLocalizedMessage({intl, stringId: 'log.clear'})}</Button>
                    </Row>
                    <Row alignmentHorizontal="end">
                        <DownloadFile {...downloadFileProps}/>
                    </Row>
                </Row>
                <Box type="fill" spacingInset="small"></Box>
                <Row alignmentHorizontal="justify" width="100%" widths={["50%","30%","20%"]} spacing="400">
                    <SearchField
                        value={logData.filterQuery}
                        onChange={(value) => {
                            logData.filterQuery = value
                            filterLogs()
                        }}
                        placeholder={getLocalizedMessage({intl, stringId: 'log.filterBySubstring'})}
                        size="small"
                    />
                    <Select
                        value={logData.deviceNameQuery}
                        onChange={(value) => {
                            logData.deviceNameQuery = value;
                            filterLogs()
                        }}
                        placeholder={getLocalizedMessage({intl, stringId: 'log.filterByDeviceName'})}
                        width={300}
                        size="small"
                    >
                        {deviceList.map((device) => {return (<SelectOption value={device.name} label={device.name} />)})}
                        <SelectOption value={EMPTY_STRING} label={ALL_CONFIG} />
                    </Select>
                    <Row alignmentHorizontal="end">
                        <Input
                            value={messageCount}
                            onChange={(value) => {
                                if (!isNaN(value)) {
                                    setMessageCount(value)
                                    setMaxMessageCount(value)
                                }
                                (value > 300) ? setErrorMsg(getLocalizedMessage({intl, stringId: 'log.messageCountError'}))
                                    : setErrorMsg(EMPTY_STRING)
                            }}
                            type="number"
                            placeholder={getLocalizedMessage({intl, stringId: 'log.messagesToCapture'})}
                            size="small"
                            errorMessage={errorMsg}
                            width={170}
                        />
                    </Row>
                </Row>
            </Box>
        </Column>
    )
}

export default injectIntl(LogstreamTabHeader)


// WEBPACK FOOTER //
// ./src/components/commonui/LogstreamTabHeader.js